import React from "react";
import { CheckmarkFilled, CloseFilled } from "@carbon/icons-react";

export interface RecentPracticeCardProps {
  title: string;
  type: string;
  date: string;
  score: string;
  isPassed: boolean;
}

export const RecentPracticeCard = ({
  title,
  type,
  score,
  isPassed,
  date,
}: RecentPracticeCardProps) => {
  return (
    <div className="pt-5 bg-white rounded-[6px]">
      <div className="flex justify-between items-center mb-2 px-6">
        <p className={`text-[24px] font-semibold leading-[30.24px]`}>{title}</p>
        <div className="flex items-center justify-between mt-2">
          <p
            className={`text-[18px] font-normal leading-[22.68px] flex items-center gap-2 ${isPassed ? "text-green-700" : "text-red-500"}`}>
            {score} {isPassed ? <CheckmarkFilled size={18} /> : <CloseFilled size={18} />}
          </p>
        </div>
      </div>
      <div className="px-6 flex flex-col justify-start items-start gap-[6px] pb-8 pt-4">
        <div className="flex flex-col gap-[6px]">
          <div className="flex flex-row gap-[6px]">
            <p className="text-[16px] leading-[20.16px] text-black">{type}</p>
          </div>
          <div>
            <p className="text-[16px] leading-[20.16px] text-black">{date}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
